import resourcesService from './resourcesService'

export default resourcesService






// WEBPACK FOOTER //
// ../src/services/resourcesService/index.js